<div class="card ml-2 mr-2 mt-2"
     [ngClass]="selectedRelatedItemBackground?.urn === relatedItem?.urn ? selectedRelatedItemBackground.background : null">
  <div class="card-body p-2 ">
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <!-- <h5 class="card-title mb-0"
            (click)="onSelectRelatedObjectToHighlight(relatedItem)"
            role="button"
            style="cursor: pointer;">{{relatedItem?.alias}}
        </h5> -->
        <button type="button"
                ngbTooltip="Seleziona sulla mappa"
                placement="right"
                [disabled]="(selectedRelatedItemBackground?.background ==='bg-warning') && selectedRelatedItemBackground?.urn == relatedItem?.urn"
                (click)="onSelectRelatedObjectToHighlight(relatedItem)"
                class="btn btn-outline-secondary rounded-lg border-0">
          <strong>{{relatedItem?.alias | uppercase}}</strong>
        </button>
        <div>
          <button type="button"
                  ngbTooltip="Vai al dettaglio"
                  (click)="relatedItem.clickable && onSelectRelatedObjectForInfo(relatedItem);"
                  class="btn btn-outline-secondary rounded-lg border-0">
            <fa-icon aria-hidden="true"
                     [icon]="icons.faInfoCircle"></fa-icon>

          </button>
          <button type="button"
                  ngbTooltip="Modifica geometria"
                  (click)="onSelectRelatedObjectToEdit(relatedItem);"
                  class="btn btn-outline-secondary rounded-lg border-0">
            <fa-icon aria-hidden="true"
                     [icon]="icons.faEdit"></fa-icon>
          </button>
          <button type="button"
                  ngbTooltip="Deseleziona"
                  [disabled]="(selectedRelatedItemBackground?.background ==='none') || selectedRelatedItemBackground?.urn !== relatedItem?.urn"
                  (click)="onDeselectRelatedObject(relatedItem);"
                  class="btn btn-outline-secondary rounded-lg border-0">
            <strong>X</strong>
          </button>
        </div>
      </div>
      <p class="card-text">{{relatedItem?.label}}</p>
    </div>

  </div>
</div>